import React, { useEffect, useState } from "react";
import "./batchPayslip.css";
import Pagelayout from "../components/Pagelayout";
import { useNavigate } from "react-router-dom";
import { getBatchPayslipList, deleteBatchPayslip } from "../parollAPIs";
import { extractValues, toSystemDate, toUTC } from "../../../../util/utilityFunctions";
import { useDispatch, useSelector } from "react-redux";
import { setStatusShowOption } from "../../../filter/filterSlice";
import { setPaginationData } from "../payrollSlice";
import { Box, Skeleton, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const BatchPayslip = () => {
  const dispatch = useDispatch();
  localStorage.removeItem("singleViewId");

  // Fallback to ensure paginationData is always defined
  const { paginationData, searchInput, filterData } = useSelector((state) => state.payrollSlice || {});

  // Ensure paginationData always has default values
  const currentPaginationData = paginationData ?? { currentPage: 1, totalPages: 1 };

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleCreateBtn = () => {
    navigate("create");
  };

  const [listData, setListData] = useState([]);
// console.log(listData);

  useEffect(() => {
    dispatch(setStatusShowOption(["DRAFT", "POSTED", "COMPUTED", "DONE"]));

    if (filterData) {
      setLoading(true);
      getBatchPayslipList({
        page: currentPaginationData.currentPage,
        limit: 10,
        search: searchInput || "",
        branchId: extractValues(filterData?.branch || []),
        department: extractValues(filterData?.department || []),
        status: extractValues(filterData?.status, "uppercase"),
        fromDate: toUTC(filterData?.date.from),
        toDate: toUTC(filterData?.date.to),
        successCallback: (data) => {
          //  console.log("API Response:", data);
          setLoading(false);
          setListData(data);
          dispatch(
            setPaginationData({
              currentPage: currentPaginationData?.currentPage || 1,
              totalPages: data?.totalPages || 0,
            })
          );
        },
        errorCallback: (error) => {
          setLoading(false);
          setListData([]);
          setSnackbar({
            open: true,
            message: error?.message,
            severity: "error",
          });
        },
      });
    }
  }, [
    searchInput,
    currentPaginationData?.currentPage,
    filterData?.employee,
    filterData?.branch,
    filterData?.date,
    filterData?.department,
    filterData?.status,
  ]);

  const handleRowClick = (rowData) => {
    navigate("create", { state: { _id: rowData?._id } });
    localStorage.setItem("singleViewId", rowData?._id);
  };

  const handleDelete = (e, payslip) => {
    e.stopPropagation(); // Prevent row click
    console.log("🗑️ Deleting batch:", payslip);
    
    if (window.confirm(`Are you sure you want to delete batch "${payslip?.batchName}"?`)) {
      deleteBatchPayslip({
        id: payslip?._id,
        successCallback: (data) => {
          console.log("✅ Deleted successfully:", data);
          setSnackbar({
            open: true,
            message: `Batch "${payslip?.batchName}" deleted successfully`,
            severity: "success",
          });
          // Refresh the list
          window.location.reload();
        },
        errorCallback: (error) => {
          console.error("❌ Error deleting:", error);
          setSnackbar({
            open: true,
            message: error?.message || "Failed to delete batch",
            severity: "error",
          });
        },
      });
    }
  };

  return (
    <Pagelayout
      pagination={currentPaginationData.totalPages > 1}
      handleCreateBtn={handleCreateBtn}
      pageName={"Batch Payslip"}
      headerLayout={1}
      snackbar={snackbar}
      setSnackbar={setSnackbar}
      filterOptions={["date", "branch", "status", "department"]}
    >
      {loading ? (
        // Skeleton loading state
        <Box>
          {[...Array(3)].map((_, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                mb: 2,
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
              }}
            >
              {/* Left border */}
              <Skeleton
                variant="rectangular"
                width={8}
                height={100}
                sx={{ bgcolor: "#e0e0e0" }}
              />
              {/* Content */}
              <Box sx={{ p: 2, flex: 1 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Skeleton variant="text" width="30%" />
                  <Skeleton variant="text" width="40%" />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Skeleton variant="text" width="20%" />
                  <Skeleton variant="text" width="25%" />
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <div className="batch-payslip__container">
          {listData?.length > 0 ? (
            listData?.map((payslip, index) => (
              <div
                key={index}
                className="batch-payslip__card"
                onClick={() => handleRowClick(payslip)}
              >
                <div className="batch-payslip__left-border"></div>
                <div className="batch-payslip__content">
                  <div className="batch-payslip__field">
                    <label className="batch-payslip__label">NAME</label>
                    <div className="batch-payslip__value">{payslip?.batchName}</div>
                  </div>
                  <div className="batch-payslip__field">
                    <label className="batch-payslip__label">PERIOD</label>
                    <div className="batch-payslip__period">
                      <span>{toSystemDate(payslip?.fromDate)}</span>
                      <span>{toSystemDate(payslip?.toDate)}</span>
                    </div>
                  </div>
                </div>
                {payslip?.status === "DRAFT" && (
                  <IconButton
                    onClick={(e) => handleDelete(e, payslip)}
                    size="small"
                    sx={{ 
                      position: 'absolute', 
                      top: 8, 
                      right: 8,
                      color: 'error.main',
                      '&:hover': {
                        backgroundColor: 'error.light',
                        color: 'white'
                      }
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}
              </div>
            ))
          ) : (
            <div>No Data Found</div>
          )}
        </div>
      )}
    </Pagelayout>
  );
};

export default BatchPayslip;
